import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCogs, 
  faClipboardList, 
  faShieldAlt, 
  faRobot, 
  faChartLine, 
  faLaptopCode, 
  faBrain, 
  faDatabase, 
  faVrCardboard 
} from '@fortawesome/free-solid-svg-icons';
import useResponsive from '../../hooks/useResponsive';
import './ProductSection.scss';

interface ServiceCardProps {
  icon: any;
  title: string;
  description: string;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ icon, title, description }) => {
  return (
    <Col lg={4} md={6} className="mb-4">
      <div className="service-card">
        <div className="service-icon">
          <FontAwesomeIcon icon={icon} />
        </div>
        <div className="service-title">
          <h4>{title}</h4>
        </div>
        <div className="service-description">
          <p>{description}</p>
        </div>
      </div>
    </Col>
  );
};

const ProductSection: React.FC = () => {
  const { isMobile } = useResponsive();
  
  const services = [
    {
      icon: faCogs,
      title: "Consultoría IT",
      description: "Asesoramiento en estrategias tecnológicas para alinear la infraestructura IT con los objetivos empresariales."
    },
    {
      icon: faClipboardList,
      title: "Gestión de Proyectos",
      description: "Gestión integral de proyectos desde la concepción hasta la implementación."
    },
    {
      icon: faShieldAlt,
      title: "Ciberseguridad",
      description: "Implementamos ciberseguridad de primer nivel en cada proyecto, utilizando IA para proteger tus sistemas contra amenazas."
    },
    {
      icon: faRobot,
      title: "Automatización de Procesos",
      description: "Análisis empresarial para identificar áreas que puedan ser automatizadas, optimizando las operaciones."
    },
    {
      icon: faChartLine,
      title: "Analítica de Datos",
      description: "Análisis de datos para descubrir insights accionables que impulsen mejores decisiones empresariales."
    },
    {
      icon: faLaptopCode,
      title: "Desarrollo de Software",
      description: "Desarrollamos aplicaciones de escritorio, web y móviles adaptadas a las necesidades específicas de tu negocio."
    },
    {
      icon: faBrain,
      title: "Inteligencia Artificial",
      description: "Soluciones avanzadas de IA que incluyen visión por computadora y modelos de lenguaje de gran escala (LLMs)."
    },
    {
      icon: faDatabase,
      title: "Machine Learning",
      description: "Desarrollo e implementación de modelos de aprendizaje automático para predecir tendencias y optimizar operaciones."
    },
    {
      icon: faVrCardboard,
      title: "Realidad Aumentada/Virtual",
      description: "Creación de experiencias inmersivas de AR/VR para capacitación y soluciones interactivas."
    }
  ];

  // Remove the slice operation to display all services
  const displayedServices = services;

  return (
    <section className="product-section">
      <Container>
        <h2 className="section-title">Nuestros Servicios</h2>
        <Row className="mb-4">
          <Col className="text-center">
            <p className="section-description">
              Ofrecemos servicios de vanguardia que impulsan la eficiencia, la seguridad y el crecimiento tecnológico de nuestros clientes.
              {!isMobile && " Impulsamos la innovación y el progreso ofreciendo un portafolio integral de soluciones tecnológicas que transforman la forma en que las empresas operan."}
            </p>
          </Col>
        </Row>

        <Row>
          {displayedServices.map((service, index) => (
            <ServiceCard 
              key={index}
              icon={service.icon}
              title={service.title}
              description={service.description}
            />
          ))}
        </Row>
      </Container>
      
      <div className="divider-container">
        <hr className="custom-divider" />
      </div>
    </section>
  );
};

export default ProductSection;